import styled from 'styled-components';
import {
  mqXLargeMin,
  mqSmallMax,
  mqLargeMin,
} from 'styled/tools/media-queries';
import {
  Fontw35s32h40,
  Fontw35s48h56,
  Fontw4s16h24,
  Fontw5s14h24,
} from 'styles/commonCss';
import FullscriptLogo from './FullscriptLogo';
import Button from 'components/reusable/Button';
import Url from 'lib/siteurls';
import Image from 'next/image';

const Section = styled.section`
  background-color: var(--fill-bright);
  display: flex;
  justify-content: center;
  padding: 48px 48px;
  flex-direction: column;

  @media ${mqSmallMax} {
    padding: 48px 24px;
  }

  @media ${mqLargeMin} {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 48px 72px 48px;
  }
`;

const Content = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
  width: 100%;
  flex-shrink: 0;

  @media ${mqLargeMin} {
    width: 50%;
    margin-bottom: 0;
  }
`;

const Title = styled.div`
  ${Fontw35s32h40}

  span {
    ${Fontw35s32h40}
  }

  .lt-break {
    display: none;
  }

  .sm-break {
    display: none;
  }

  @media ${mqLargeMin} {
    ${Fontw35s48h56}
    letter-spacing: -0.48px;

    span {
      ${Fontw35s48h56}
      letter-spacing: -5.28px;
    }
  }

  @media (${mqXLargeMin}) {
    .lt-break {
      display: block;
    }
  }

  @media ${mqSmallMax} {
    .sm-break {
      display: block;
    }
  }
`;

const Description = styled.p`
  ${Fontw4s16h24}
  max-width: 518px;

  .sm-break {
    display: none;
  }

  @media ${mqSmallMax} {
    .sm-break {
      display: block;
    }
  }
`;

const FullscriptButton = styled(Button)`
  ${Fontw5s14h24}
  padding: 0;
  height: 60px;
  text-decoration: none;

  @media ${mqLargeMin} {
    max-width: 288px;
  }
`;

const RecommendOnFullscript = () => {
  return (
    <Section className='recommend-section'>
      <div
        style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '660/495',
          margin: '0 auto',
        }}
      >
        <Image
          src='https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1789147404/practitioners/fullscriptproducts.png'
          alt='Seed Product Family'
          fill
          style={{ objectFit: 'contain' }}
        />
      </div>
      <Content>
        <FullscriptLogo />
        <Title>
          Recommend Seed Synbiotics to Your Patients with Fullscript
        </Title>
        <Description>
          Seamlessly access Seed supplements through Fullscript® for direct
          delivery to your patients or convenient distribution from your office.
        </Description>
        <FullscriptButton
          as='a'
          href={Url.fullscript}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Seed on Fullscript®. Opens in a new tab.'
        >
          Recommend Seed on Fullscript®
        </FullscriptButton>
      </Content>
    </Section>
  );
};

export default RecommendOnFullscript;
